import {useEffect,useState} from 'react';

// visualViewport follows the usable screen when the keyboard opens or zoom changes.
export function useOverlayViewport() {
  const read=()=>({left:window.visualViewport?.offsetLeft??0,top:window.visualViewport?.offsetTop??0,width:window.visualViewport?.width??window.innerWidth,height:window.visualViewport?.height??window.innerHeight});
  const [viewport,setViewport]=useState(read);
  useEffect(()=>{
    const update=()=>setViewport(read());
    window.addEventListener('resize',update);
    window.visualViewport?.addEventListener('resize',update);
    window.visualViewport?.addEventListener('scroll',update);
    return()=>{window.removeEventListener('resize',update);window.visualViewport?.removeEventListener('resize',update);window.visualViewport?.removeEventListener('scroll',update);};
  },[]);
  return viewport;
}
